import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';

const PaymentInformationFiservCreditDisplay = ({ fiserv, cardNumber }) => {
	let icon = 'credit card';
	switch (fiserv.fundingMethod) {
		case 'visa':
			icon = 'cc visa';
			break;
		case 'mastercard':
			icon = 'cc mastercard';
			break;
		case 'american-express':
			icon = 'cc amex';
			break;
		default:
			icon = 'credit card';
			break;
	}

	const cardDisplay = useMemo(() => {
		if(fiserv.fundingAccountLastFourDigits) {
			return <span>*{fiserv.fundingAccountLastFourDigits}</span>
		} else {
			return <span>{cardNumber}</span>
		}
	}, [cardNumber, fiserv.fundingAccountLastFourDigits])

	return (
		<div>
			<Icon name={icon} size='large' />
			{cardDisplay}
		</div>
	);
};

PaymentInformationFiservCreditDisplay.propTypes = {
	fiserv: PropTypes.object.isRequired
};

export default PaymentInformationFiservCreditDisplay;
